var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 472.615 472.615",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M436.475,103.262c-19.961,0-36.141,16.18-36.141,36.141c0,9.776,3.92,18.613,10.226,25.12l-74.195,71.928l-76.969-122.068 c12.207-7.695,20.378-21.202,20.378-36.7c0-24.005-19.46-43.467-43.466-43.467c-24.005,0-43.465,19.462-43.465,43.467 c0,15.468,8.139,28.961,20.31,36.666l-76.938,122.101L62.05,164.528c6.311-6.505,10.232-15.346,10.232-25.125 c0-19.961-16.181-36.141-36.141-36.141S0,119.442,0,139.403c0,19.959,16.181,36.139,36.141,36.139 c2.196,0,4.322-0.272,6.411-0.647l34.27,166.474h318.972l34.27-166.474c2.088,0.378,4.215,0.647,6.412,0.647 c19.96,0,36.14-16.18,36.14-36.139C472.615,119.442,456.435,103.262,436.475,103.262z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "391.714,361.061 80.875,361.061 62.108,438.398 410.481,438.398  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCrown);
export default __webpack_public_path__ + "static/media/filledCrown.0d6d971b327466cc2af245996e09cba8.svg";
export { ForwardRef as ReactComponent };